module.exports = __webpack_public_path__ + "img/tv-box2.81177a7f.png";